import React from "react";
import { personalInfo } from "../data/content";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-rule bg-canvas py-10">
      <div className="wrap flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="font-mono text-[0.6875rem] uppercase tracking-[0.06em] text-ink-muted">
          © {year} {personalInfo.name}
        </p>
        <p className="font-mono text-[0.6875rem] uppercase tracking-[0.06em] text-ink-muted">
          {personalInfo.location} · {personalInfo.positioning}
        </p>
      </div>
    </footer>
  );
}
